import React, { useState, useEffect } from "react";
import "./App.css";
import "./i18n"; // Initialize i18n
import MobileUpload from "./components/MobileUpload";
import TaskView from "./components/TaskView";
import LanguageSwitcher from "./components/LanguageSwitcher";
import { useTranslation } from 'react-i18next';
import { getViewTokenFromHash, parseTaskViewToken } from './utils/shareLink';

function App() {
  const { t } = useTranslation();
  const [viewParams, setViewParams] = useState(null);
  const [viewError, setViewError] = useState(false);

  useEffect(() => {
    const checkHash = () => {
      const token = getViewTokenFromHash();
      if (token) {
        const params = parseTaskViewToken(token);
        if (params) {
          setViewParams(params);
          setViewError(false);
        } else {
          setViewParams(null);
          setViewError(true);
        }
      } else {
        setViewParams(null);
        setViewError(false);
      }
    };

    checkHash();
    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);

  if (viewError) {
    return (
      <div className="app">
        <nav className="app-nav">
          <div className="nav-header">
            <h1 className="nav-title">{t('app.title')}</h1>
          </div>
          <LanguageSwitcher />
        </nav>
        <div style={{
          maxWidth: '100%',
          padding: '20px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: '100vh',
        }}>
          <div style={{
            background: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(10px)',
            borderRadius: '20px',
            padding: '40px 20px',
            textAlign: 'center',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          }}>
            <h3 style={{ color: '#991b1b', margin: '0 0 8px' }}>{t('taskView.invalidLink')}</h3>
            <p style={{ color: '#6b7280', margin: 0 }}>{t('taskView.invalidLinkDesc')}</p>
          </div>
        </div>
      </div>
    );
  }

  if (viewParams) {
    return (
      <div className="app">
        <nav className="app-nav">
          <div className="nav-header">
            <h1 className="nav-title">{t('taskView.title')}</h1>
            <p className="nav-subtitle">{t('taskView.subtitle')}</p>
          </div>
          <LanguageSwitcher />
        </nav>
        <TaskView
          propertyAddress={viewParams.property_address}
          taskType={viewParams.task_type}
          taskDate={viewParams.task_date}
        />
      </div>
    );
  }

  return (
    <div className="app">
      <nav className="app-nav">
        <div className="nav-header">
          <h1 className="nav-title">{t('app.title')}</h1>
          <p className="nav-subtitle">{t('app.subtitle')}</p>
        </div>
        <LanguageSwitcher />
      </nav>
      <MobileUpload />
    </div>
  );
}

export default App;
